import { render, staticRenderFns } from "./SortTable.vue?vue&type=template&id=b1d27cb4&"
import script from "./SortTable.vue?vue&type=script&lang=js&"
export * from "./SortTable.vue?vue&type=script&lang=js&"
import style0 from "./SortTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports